
  import GameReleaseService from "@/services/GameReleaseService";
import { Helper } from "@/utils/Helper";
import ResponseData from "@/_models/ResponseData";
import { ref } from "vue";
import { useRoute } from "vue-router";
  import { useStore } from "vuex";
  export default{
  name: 'gamesDeleteReleaseModal',
    props: {
      displayConfirmDeleteModal: Boolean,
      showUploadingLoader: Boolean,
      isDisabledModalConfirmSubmitButton: Boolean,
      network: String,
      version: String,
      platform: String,
    },
  
    emits:[
      'closeModel', //displayConfirmDeleteModal = false
      'confirmedButtonPressed'
    ],
  
    setup(props, { emit }){
      const store = useStore();
      const route = useRoute();
      const testnetLabel = ref(store.getters['config/configTestnetLabel']);
      const mainnetLabel = ref(store.getters['config/configMainnetLabel']);
      const testneturl = ref(store.getters['config/getTestnetApi']);
      const mainneturl = ref(store.getters['config/getMainnetApi']);
      const userData = store.getters["auth/user"] ?? "";
      const jwtToken = store.getters["auth/jwtToken"] ?? "";
  
      const confirmedButtonPressed = async () => {
        let gameId = route.params.gameId.toString();
        await GameReleaseService.deleteRelease(gameId, userData.userId, jwtToken, props.version, props.platform)
        .then((response: ResponseData) => {
          Helper.toastSuccessHandling(response.data['message']);
          emit('deleteReleaseModalSuccess');
        }).catch((error) => {
            Helper.endpointErrorHandling(error);
        });
      }
  
      const isFullQRModalShow = ref(false);
  
      return {
        testnetLabel,
        mainnetLabel,
        testneturl,
        mainneturl,
        confirmedButtonPressed,
        isFullQRModalShow,
      }
    }
  }
  